export default __webpack_public_path__ + "static/media/canHasNoShift.d85216b0.svg";